import React, { useState } from 'react';
import { FestivalCard, FestivalForm } from './';
import { Loading } from '../controls';
import Portal from '../modal';
import { useFestivalsQuery } from '../../queries/festivals';

export function Festivals() {
  const [showModal, setShowModal] = useState(false);
  const { data: festivals = [], isPending, isError } = useFestivalsQuery();

  const addNewFestival = (e) => {
    e.preventDefault();
    setShowModal(true);
  };

  if (isPending) {
    return <Loading />;
  }

  if (isError) {
    return (
      <div className="mt-16 text-center text-red-600">
        Could not load festivals. Try refreshing the page.
      </div>
    );
  }

  return (
    <>
      <div className="mt-10 flex flex-wrap justify-center gap-6">
        <FestivalCard festival={null} onClick={addNewFestival} />
        {festivals.map((festival) => (
          <FestivalCard festival={festival} key={festival.festivalId} />
        ))}
      </div>

      <Portal
        header="Add New Festival"
        open={showModal}
        onClose={() => setShowModal(false)}
      >
        <FestivalForm />
      </Portal>
    </>
  );
}
